import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/** 江西检测报告查询接口。 */
export const reportService = {
  pendingPage: params => axios.get(`${iffApi}/jxxf/jc/report/pending`, { params }),
  page: params => axios.get(`${iffApi}/jxxf/jc/report`, { params }),
  preview: xmId => axios.post(`${iffApi}/jxxf/jc/report/${xmId}/preview`),
  generate: xmId => axios.post(`${iffApi}/jxxf/jc/report/${xmId}/generate`),
  uploadSealedReport: (xmId, fileId) => axios.post(`${iffApi}/jxxf/jc/report/${xmId}/sealed-report`, { fileId })
};
